// @flow

import {
	SET_USER,
	RESET_USER,
	FETCH_LATLNG,
	FETCH_LATLNG_SUCCESS,
	FETCH_USER_DETAILS,
	FETCH_USER_DETAILS_SUCCESS,
	FETCH_USER_DETAILS_ERROR,
} from './types';
import type { Action } from '../actions/types';

export const setUser = (userData: {}): Action => ({
	type: SET_USER,
	payload: userData,
});

export const resetUser = (): Action => ({
	type: RESET_USER,
});

export const fetchUserLatlng = (): Action => ({
	type: FETCH_LATLNG,
});

export const fetchUserLatlngSuccess = (coords: {}): Action => ({
	type: FETCH_LATLNG_SUCCESS,
	payload: coords,
});

export const fetchUserDetails = (mobile: string): Action => ({
	type: FETCH_USER_DETAILS,
	payload: mobile,
});

export const fetchUserDetailsSuccess = (name: string, email: string): Action => ({
	type: FETCH_USER_DETAILS_SUCCESS,
	payload: { name, email},
});

export const fetchUserDetailsError = (error: Error): Action => ({
	type: FETCH_USER_DETAILS_ERROR,
	payload: error,
});
